import { safeJsonParse } from "./Json";
import { defaultNotificationConfig } from "../config/user";

const CHANNELS = ["push", "email"];

//The form shows one checkbox per alert type in the default config. A type missing from the stored
//config is shown as off, which is how the backend treats it when it picks who to notify.
export const buildNotifyFormValues = (storedConfig) => {
	const config = safeJsonParse(storedConfig, {}, "notify config") ?? {};

	return Object.fromEntries(
		CHANNELS.map((channel) => [
			channel,
			Object.fromEntries(
				Object.keys(defaultNotificationConfig[channel]).map((type) => [type, config[channel]?.[type] === true])
			),
		])
	);
};

//Saving replaced the whole stored config with the form values, so any alert type the form did not
//show (for example one set in the mobile app) was lost. Merge the form values into the stored
//config instead, so keys the form does not know about are kept.
export const mergeNotifyConfig = (storedConfig, formValues) => {
	const config = safeJsonParse(storedConfig, {}, "notify config") ?? {};

	return {
		...config,
		...Object.fromEntries(
			CHANNELS.map((channel) => [channel, { ...(config[channel] ?? {}), ...(formValues?.[channel] ?? {}) }])
		),
	};
};

//The id of a user's default settings record for a scheme. It must match defaultConfigId in the
//cognito-postlogin Lambda (andel-cloud-lambdas), which creates the same record after sign-in. With
//the same id, whichever writes second gets a failed condition instead of creating a duplicate.
export const defaultNotifyConfigId = (cognitoUserId, schemeId) => `notify-default-${cognitoUserId}-${schemeId}`;

//Amplify rejects with the GraphQL result when it has errors. A create of an id that already exists
//fails its condition check.
export const isConditionalCheckFailed = (error) =>
	!!error?.errors?.some((e) => String(e?.errorType ?? "").includes("ConditionalCheckFailedException"));
